import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import CaptainTCCardsContent from "../../components/CaptainTCCardsContent";
import "./CaptainTCCards.css";

const CaptainTCCards = () => {
  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <PageTitle
            pageTitle={"Captain TC Collectable Cashback Card"}
            pagesub={"Home"}
          />
          <div className="captain-tc-cards-page">
            <CaptainTCCardsContent />
          </div>
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
};

export default CaptainTCCards;
